import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsSupportWebsitePagesRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-support-website-details-pages',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
	exact: true,
};
